import { rtkApi } from '../../rtkApi';

export interface AdminUploadedDocument {
  _id: string;
  source: 'loan_application' | 'contract';
  title: string;
  fileName: string;
  size: number;
  mimeType: string;
  storage: 's3' | 'local';
  uploadedAt: string;
  downloadCount: number;
  downloadedAt: string | null;
  context: string;
  /** Relative to the API base, e.g. /loan-applications/documents/file/:id/download */
  downloadPath: string;
}

export const adminDocumentsApi = rtkApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getBuyerUploadedDocuments: builder.query<AdminUploadedDocument[], string>({
      query: (userId) => ({
        url: `/admin/documents/user/${userId}`,
        method: 'GET',
      }),
      transformResponse: (r: {
        success: boolean;
        data: AdminUploadedDocument[];
      }) => r.data,
    }),
  }),
});

export const { useGetBuyerUploadedDocumentsQuery } = adminDocumentsApi;
